import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const ProfileView = lazy(() => import('./ProfileView'));

const profileRoutes: FuseRouteItemType[] = [
	{
		path: 'profile',
		element: <ProfileView />
	}
];

export default profileRoutes;
